import { Component, OnInit } from '@angular/core';
import { PlayerService } from 'src/app/services/player.service';
import { GroupService } from 'src/app/services/group.service';
import { Player } from 'src/app/objects/player';
import { Router } from '@angular/router';
import { Group } from 'src/app/objects/group';
import { catchError, finalize } from 'rxjs/operators';

@Component({
  selector: 's18-player-profile-credits',
  templateUrl: './player-profile-credits.component.html',
  styleUrls: ['./player-profile-credits.component.scss']
})
export class PlayerProfileCreditsComponent implements OnInit {
  player: Player;
  leagues: Group[];
  working: boolean = false;

  constructor(
    private playerService: PlayerService,
    private groupService: GroupService,
    private router: Router
  ) { }

  ngOnInit() {
    this.working = true;
    this.player = this.playerService.getLoggedInPlayerInfo();

    if (this.player == null) {
      this.router.navigateByUrl("login");
    }

    this.playerService.getGroups(this.player.player_id.toString(), "2")
      .pipe(catchError(err => {
        return "error";
      }),
        finalize(() => {
          this.working = false;
        }))
      .subscribe(resp => {
        this.leagues = JSON.parse(resp.d).groups;
        this.fetchCredits();
      });
  }

  fetchCredits() {
    var callCount = 0;
    this.working = true;
    this.leagues.forEach(e => {
      callCount++;
      this.groupService.getPlayerLedger(e.group_id.toString(), this.player.player_id.toString())
        .pipe(catchError(err => {
          return "error";
        }),
          finalize(() => {
            callCount--;
            if (callCount === 0) {
              this.working = false;
            }
          }))
        .subscribe(resp => {
          e.total_credits = 0;
          e.credits_awarded = 0;
          e.credits_used = 0;
          e.ledger = JSON.parse(resp.d).player_ledger;
          e.ledger.forEach(el => {
            e.total_credits += +el.value_in_cents / 100;
            if (el.value_in_cents < 0) {
              e.credits_used += +el.value_in_cents / 100
            }
            else {
              e.credits_awarded += +el.value_in_cents / 100
            }
          });
        });
    });
  }
}
